import { FileUploadComponent } from "./component";
export const Fileupload = FileUploadComponent;
